import React from 'react'
import cn from 'classnames'
import Link from 'redux-first-router-link'
import styled from 'react-emotion'
import { themeGet as th } from 'styled-system'

const stopPropagation = ev => ev.stopPropagation()

const CloseIcon = ({ className, to }) => {
  return (
    <Link
      className={cn(className, 'Icon Icon-close')}
      to={to}
      onClick={stopPropagation}
      tabIndex="-1"
      redirect // i.e. behave like a modal: back button shouldn't take us back here
    />
  )
}

export default styled(CloseIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: ${th('colors.gray')} !important; /* or sui.a borks it */
  background-color: ${th('colors.white')};
  border-radius: ${th('radius')};
  cursor: pointer;
  z-index: 1;

  &:hover {
    transition: color 0.2s ease-in-out;
  }
`
